<template>
  <v-card class="mt-3">
    <v-progress-linear v-if="loading" :indeterminate="loading" absolute>
    </v-progress-linear>
    <v-row no-gutters>
      <v-col cols="0">
        <MachineLi :machine="subjob.Machine" :disabled="true" :showServiceAgreement="false"
          style="padding-left: 12px !important;" />
      </v-col>
      <v-col cols="auto">
        <RefreshBtn :method="getSubJobLogg" :externalLoading="loading"
          :tip="$t('servicesystem.common_objects.commonterms.refresh_list')" :size="'small'" class="ma-3">
        </RefreshBtn>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-list dense style="max-height: 45vh; overflow-y: auto; background-color: #fbfbfb;" id="container">
      <p v-if="!subjob.Loggs || subjob.Loggs.length < 1" class="ma-0 text-center">
        {{ $t('servicesystem.common_objects.fallbackterms.no_loggs') }}
      </p>
      <logg-li v-for="loggitem in subjob.Loggs" :key="loggitem.Id" :item="loggitem">
      </logg-li><!-- @fetch="select" -->
    </v-list>

    <v-divider></v-divider>
    <v-list-item dense class="px-3">
      <v-list-item-content class="py-0 pr-3">
        <v-list-item-title>
          <QTextField v-model="newMessage" :key="refreshkey" :loading="createloading" :disabled="createloading"
            :placeholder="$t('servicesystem.common_objects.fallbackterms.write_message_here')" class="pt-1" clearable :externaledit="true">
          </QTextField>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action v-if="!createloading" class="ma-0">
        <v-btn :disabled="createloading || !newMessage" color="primary" icon small @click="create()">
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import LoggLi from "@/components/ListItems/LoggListItem.vue";
import MachineLi from "@/components/ListItems/MachineListItem.vue";
import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";

export default {
  name: "SupportLoggCard",
  props: {
    subjob: Object,
  },
  components: {
    LoggLi,
    MachineLi,
    RefreshBtn,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
      createloading: false,
      newMessage: null,
      refreshkey: 1,
    };
  },

  mounted() {
    this.getSubJobLogg();
  },

  methods: {
    getSubJobLogg() {
      this.loading = true;
      this.getLoggByJobId(this.subjob.Id)
        .then((response) => {
          const update = { id: this.subjob.Id, key: "Loggs", value: response };
          this.$store.dispatch("JobHub/JobSubjobs/setSubjobDetail", update);
        })
        .catch((exception) => console.log(exception))
        .finally(() => {
          this.loading = false;
          this.scrollToBottom();
        });
    },

    create() {
      this.createloading = true;
      var dto = {
        Id: null,
        JobId: this.subjob.Id,
        TimerDate: new Date().toJSON(),
        TimerDuration: null,
        Comment: this.newMessage,
        UserDisplayName: this.userInfo.Name,
        UserId: this.userInfo.Id,
      };
      this.createLogg(dto)
        .then((response) => {
          this.newMessage = null;
          this.refreshkey++;
          Vue.set(this.subjob.Loggs, this.subjob.Loggs.length, response);
          setTimeout(() => this.scrollToBottom(), 200);
        })
        .catch(() => { })
        .finally(() => {
          this.createloading = false;
        });
    },

    scrollToBottom() {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    }
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>